'use strict';

var objectWithoutProperties = require('../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var classNames = require('classnames');
var Card = require('../../../../DesignSystem/Surfaces/Cards/Card.js');
var CardHeader = require('../../../../DesignSystem/Surfaces/Cards/CardHeader.js');
var CardContent = require('../../../../DesignSystem/Surfaces/Cards/CardContent.js');
var withStyles = require('../../../../DesignSystem/Styles/withStyles.js');
var Grid = require('../../../../DesignSystem/Layout/Grid/Grid.js');
var Typography = require('../../../../DesignSystem/DataDisplay/Typography/Typography.js');
require('prop-types');
var Star = require('../../../../IconsAndImages/Icons/Star.js');
var CardButton = require('../../../../DesignSystem/Inputs/Buttons/CardButton.js');
var Tooltip = require('../../../../DesignSystem/DataDisplay/Tooltips/Tooltip.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var styles = {
  cardWidth: {
    minWidth: 89
  },
  cardContainer: {
    position: 'relative',
    height: 115
  },
  cardContentStyle: {
    padding: '0 12px 12px 12px',
    marginTop: -4
  },
  starPosition: {
    position: 'relative',
    top: 4,
    left: -4
  }
};

var ReviewSiteSummaryCard = function ReviewSiteSummaryCard(_ref) {
  var classes = _ref.classes,
      icon = _ref.icon,
      reviewSite = _ref.reviewSite,
      reviewSiteBrandColor = _ref.reviewSiteBrandColor,
      overallRating = _ref.overallRating,
      totalRatings = _ref.totalRatings,
      loading = _ref.loading,
      inactive = _ref.inactive,
      onInactiveClick = _ref.onInactiveClick,
      action = _ref.action,
      restOfProps = objectWithoutProperties(_ref, ["classes", "icon", "reviewSite", "reviewSiteBrandColor", "overallRating", "totalRatings", "loading", "inactive", "onInactiveClick", "action"]);

  var buildActiveSummaryCard = function buildActiveSummaryCard(loading) {
    return React__default["default"].createElement("div", {
      className: classes.cardWidth
    }, React__default["default"].createElement(Card, restOfProps, React__default["default"].createElement("div", {
      className: classes.cardContainer
    }, React__default["default"].createElement(CardHeader, {
      icon: icon,
      title: "",
      showDivider: false,
      loading: loading,
      action: !loading && action
    }), React__default["default"].createElement(CardContent, {
      className: classes.cardContentStyle
    }, React__default["default"].createElement(Grid, {
      item: true,
      xs: 12
    }, React__default["default"].createElement(Typography, {
      variant: "h5"
    }, overallRating, " ", React__default["default"].createElement("span", {
      className: classes.starPosition
    }, React__default["default"].createElement(Star, {
      style: {
        fill: reviewSiteBrandColor
      }
    })))), React__default["default"].createElement(Grid, {
      item: true,
      xs: 12
    }, React__default["default"].createElement(Typography, {
      variant: "caption"
    }, totalRatings, " reviews"))))));
  };

  if (loading) {
    return buildActiveSummaryCard(true);
  } else if (inactive) {
    return React__default["default"].createElement(Tooltip, {
      title: "Add " + reviewSite + " reviews"
    }, React__default["default"].createElement("div", null, React__default["default"].createElement(CardButton, {
      className: classNames__default["default"](classes.cardWidth, classes.cardContainer),
      onClick: onInactiveClick
    }, icon)));
  } else {
    return buildActiveSummaryCard(false);
  }
};

ReviewSiteSummaryCard.defaultProps = {
  reviewSite: ""
};
var ReviewSiteSummaryCard$1 = withStyles["default"](styles)(ReviewSiteSummaryCard);

module.exports = ReviewSiteSummaryCard$1;
